interface IValidatorReturningValueWithErrorMessage {
  isValid: boolean
  message: string
}
// validator function also can return undefined if all field is valid
type IValidator = (value: any) => IValidatorReturningValueWithErrorMessage | undefined

interface IFielsWithValidators {
  [filedName: string]: IValidator
}

interface IFormSectionFields {
  [filedName: string]: string
}

interface IValidationResult {
  [formSectionName: string]: IFormSectionFields
}

const createFormSectionValidator = (formValidationObject: IFielsWithValidators, formSectionName: string) => (
  value: any /* form object where validator function can get necessary values for validation  */
): IValidationResult => {
  let nestedFields: IFormSectionFields = {}
  for (const fieldName in formValidationObject) {
    const validator = formValidationObject[fieldName]
    const validationResult = validator(value)
    if (validationResult) {
      nestedFields[fieldName] = validationResult.message
    }
  }
  const result = {
    [formSectionName]: nestedFields,
  }
  return result
}

export default createFormSectionValidator
